import {Component, Inject, OnChanges, OnInit, PLATFORM_ID} from '@angular/core';
import { environment } from '../../../environments/environment';
import {Router, NavigationEnd, NavigationStart} from "@angular/router";
import {AuthService} from "../../core/auth/auth.service";
import {isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  modePro: boolean;
  logoName: string;
  stepIndex: number = 0;
  message:string = 'oui';
  isSignup:boolean = false;
  isProSignupProcessgoinParent : boolean = false;
  data: string;

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private router:Router,private authService: AuthService) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.isSignup = event.url.includes('signup');
      }
    });
  	this.modePro = environment.pro;
    this.logoName = (this.modePro) ? 'logo-pro.png' : 'logo.png';
  }
  isProSignupProcessgoin() {
    return this.authService.isProSignupProcessgoin;
  }

  ngOnInit() {
    this.authService.data$.subscribe(res => {
      if(res === 'signedUp') {
        this.authService.isProSignupProcessgoin = true;
      }
    });
    if (isPlatformBrowser(this.platformId)) {
      const currentRoute = window.location.href;
      if(currentRoute.includes('signup')) {
        console.log('signUp');
        this.isSignup = true;
      } else {
        this.isSignup = false;
      }
    }
  }

  receiveMessage($event) {
    this.message = $event;
    console.log('login' + $event);
  }

  loggedIn() {
    return this.authService.loggedIn();
  }

}
